import { UserService } from '@/app/shared/services/user.service'
import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

/**
 * Réserve une route aux rôles d'écriture opérationnelle (administrateur et gestionnaires).
 * Le CPO et le lecteur pur n'y ont pas accès. Le MsalGuard parent garantit l'authentification.
 *
 * À poser sur les écrans PUREMENT transactionnels — ceux dont l'unique raison d'être est une
 * mutation — et non sur un écran de consultation qui porte accessoirement des boutons d'action :
 * ceux-là doivent rester ouverts, seules leurs actions étant masquées.
 *
 * Sans cette garde, le masquage de l'entrée de menu était l'unique protection, et l'écran restait
 * atteignable en tapant son URL.
 */
export const writeGuard: CanActivateFn = () => {
  const user = inject(UserService)
  const router = inject(Router)

  if (user.canWrite()) return true

  return router.createUrlTree(['/requisitions'])
}
